module.exports = __webpack_public_path__ + "img/device_pic_cooling.071f66ab.svg";